module.exports = __webpack_public_path__ + "static/media/Pig-web-logo.87d1565c.png";